<div *ngIf="showFab && !dialogOpen" class="tutorial-fab-wrapper">
  <span class="tutorial-fab-label">Ver vídeo</span>
  <button
    class="tutorial-fab"
    (click)="openTutorial()"
    aria-label="Ver vídeo"
  >
    <mat-icon>play_arrow</mat-icon>
  </button>
</div>
